export const formatFileSize = (sizeInBytes: number): string => {
  if (sizeInBytes < 0 || isNaN(sizeInBytes)) {
    return 'Invalid size'
  }
  if (sizeInBytes < 1024) {
    return `${sizeInBytes} Bytes`
  } else if (sizeInBytes < 1024 * 1024) {
    return `${(sizeInBytes / 1024).toFixed(1)} KB`
  } else {
    return `${(sizeInBytes / (1024 * 1024)).toFixed(1)} MB`
  }
}

export const formatDate = (date: Date): string => {
  const options: Intl.DateTimeFormatOptions = {
    hour: 'numeric',
    minute: 'numeric',
    hour12: true,
  }
  const timeString = date.toLocaleString('en-US', options).replace(':', '.') // Replace ':' with '.'

  const dateString = date.toLocaleString('en-US', {
    day: 'numeric',
    month: 'short',
  })

  return `${timeString}, ${dateString}`
}

export const formatTime = (seconds: number) => {
  const minutes = Math.floor(seconds / 60)
  const secs = seconds % 60
  return `${String(minutes).padStart(2, '0')}:${String(secs).padStart(2, '0')}`
}

// Helper function to format date and time
export type PlatformKind = 'mobile' | 'desktop' | 'web'

export const getPlatform = (): PlatformKind => {
  const ua = navigator.userAgent || ''
  const isMobile =
    /Android|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i.test(ua) ||
    (window.innerWidth <= 768 && 'ontouchstart' in window)
  return isMobile ? 'mobile' : 'desktop'
}

// Helper function to format date and time
export const formatDateTime = (isoDate: string) => {
  const date = new Date(isoDate)

  const formattedDate = date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  })

  const formattedTime = date.toLocaleTimeString('en-US', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  })

  return { formattedDate, formattedTime }
}
